/**
 * Where the Haire admin portal is mounted. Configurable per build with
 * VITE_ADMIN_PORTAL_PATH (default /haire-admin) so it is not a guessable,
 * app-linked URL. The app never links here; staff bookmark it.
 */

/** "/x/" | "x" | "" → "/x" (a leading slash, no trailing slash, never "/"). */
export function normalizeBasePath(raw, fallback = "/haire-admin") {
  const s = String(raw ?? "").trim().replace(/\/+$/, "").replace(/^\/*/, "/");
  // Reject "/", whitespace and anything that isn't a plain path.
  return s.length > 1 && /^\/[A-Za-z0-9._~\-/]+$/.test(s) ? s : fallback;
}

export const ADMIN_BASE = normalizeBasePath(import.meta.env?.VITE_ADMIN_PORTAL_PATH);

/** adminPath("outreach") → "/haire-admin/outreach". */
export const adminPath = (sub = "") => {
  const rest = String(sub || "").replace(/^\/+/, "");
  return rest ? `${ADMIN_BASE}/${rest}` : ADMIN_BASE;
};

export const ADMIN_LOGIN_PATH = adminPath("login");

/** True for the portal base and anything under it (not for /haire-adminx). */
export const isAdminPortalPath = (pathname, base = ADMIN_BASE) => {
  const p = String(pathname || "");
  return p === base || p.startsWith(`${base}/`);
};
